<template>
  <div>
    <!-- edit profile dialog -->
    <v-dialog
      v-model="isInfoDialogOpen"
      max-width="650px"
      @click:outside="$emit('update:is-info-dialog-open',false)"
    >
      <v-card class="pa-sm-10 pa-3">
        <v-card-title class="justify-center text-h5">
          Editar informações do Formulário
        </v-card-title>

        <v-card-text class="mt-5">
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="update"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="formularioDataLocale.nome"
                  outlined
                  dense
                  label="Nome"
                  :rules="[validators.required, (v) => (!!v && v.length <= 100) || 'Máximo de 100 caracteres']"
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                sm="12"
              >
                <v-textarea
                  v-model="formularioDataLocale.descricao"
                  outlined
                  dense
                  label="Descrição"
                  :rules="[validators.required, (v) => (!!v && v.length <= 200) || 'Máximo de 255 caracteres']"
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
              </v-col>

              <v-col
                cols="12"
                class="d-flex justify-end "
              >
                <v-btn
                  outlined
                  class="me-3"
                  color="secondary"
                  @click="$emit('update:is-info-dialog-open',false)"
                  @click.prevent="resetForm"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  type="submit"
                >
                  Salvar alterações
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from '@core/utils/validation'
import { ref, watch } from '@vue/composition-api'
import router from '@/router'
import FormularioService from '@/services/modules/FormularioService'

export default {
  props: {
    isInfoDialogOpen: {
      type: Boolean,
      required: true,
    },
    formularioData: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
  }),

  methods: {},

  setup(props, { emit }) {
    const formularioDataLocale = ref(props.formularioData)

    const resetForm = () => {
      formularioDataLocale.value = JSON.parse(JSON.stringify(props.formularioData))
    }

    watch(
      () => props.isInfoDialogOpen,
      () => {
        formularioDataLocale.value = JSON.parse(JSON.stringify(props.formularioData))
      },
    )

    const loading = ref(false)
    const valid = ref(false)
    const form = ref(null)

    const validate = () => {
      form.value.validate()
    }

    const update = async () => {
      loading.value = !loading.value

      if (valid.value) {
        try {
          await FormularioService.update(router.currentRoute.params.id, formularioDataLocale.value)

          loading.value = !loading.value
          emit('refresh-data')
          emit('update:is-info-dialog-open', false)
        } catch {
          loading.value = !loading.value
        }
      } else {
        loading.value = !loading.value
        validate()
      }
    }

    return {
      formularioDataLocale,
      resetForm,
      update,
      form,
      valid,
      validate,
      loading,
      validators: {
        required,
      },
    }
  },
}
</script>
